<template>
    <span class="ball" :style="'color:' + color" />
</template>

<script>

export default {
    props: {
        color: { type: String, default: 'var(--light)' },
    }
}
</script>

<style scoped>
.ball {
  display: block;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: currentColor;
  box-shadow: 0px 0px 6px -1px currentColor;
  border: 1px solid rgba(0,0,0,0.35);
  margin: 0 auto;
}
</style>